angular.module("ainapp")
    .controller("employeeAttendanceController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Employee Attendance";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.basePath = config.basePath;


            $scope.WorkTypes = [];
            MainService.WorkTypesInDropdown().then(function (response) {
                $scope.WorkTypes = response.data;
            })

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Employee Attendance").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.loadVoucher = function (data) {

                $scope.CostCenters = angular.copy($scope.CostCenters2);

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetEmployeeAttendance(data).then(function (response) {
                    if (response.data != null) {
                        $scope.addData = response.data;
                        $scope.addData.Date = new Date($scope.addData.Date);
                        $scope.checkTimings();

                        angular.forEach(response.data.EmployeeAttendanceCosts, function (e) {
                            angular.forEach($scope.CostCenters, function (a) {
                                if (e.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = e.CostCenter.Id;
                                }
                            })
                        })


                        var empIds = [];
                        angular.forEach($scope.addData.EmployeeAttendanceDetails, function (e) {
                            if (e.StartTime != null) {
                                e.StartTime = new Date(e.StartTime);
                            }
                            if (e.EndTime != null) {
                                e.EndTime = new Date(e.EndTime);
                            }
                            empIds.push(e.EmployeeId);

                            var costs = angular.copy($scope.CostCenters2);
                            if (e.EmployeeAttendanceCosts.length > 0) {
                                angular.forEach(e.EmployeeAttendanceCosts, function (ee) {
                                    angular.forEach(costs, function (a) {
                                        if (ee.CostCenter.ParentId == a.CostCenterId) {
                                            a.SelectedCostCenterId = ee.CostCenter.Id;
                                        }
                                    })
                                    e.CostCenters = angular.copy(costs);
                                })
                            } else {
                                e.CostCenters = angular.copy($scope.CostCenters2);
                            }

                        })

                        var tempemp = {
                            EmployeeIds: empIds
                        }

                        if ($state.current.name == "employeeAttendanceGrade") {

                            tempemp.GradeId = $scope.addData.GradeId;

                            MainService.GetBalanceEmployeesGrade(tempemp).then(function (response2) {
                                if (response2.data) {

                                    angular.forEach(response2.data, function (e) {
                                        var detail = {
                                            EmployeeId: e.Id,
                                            mployeeName: e.Name,
                                             EmployeeCode: e.EmployeeId,
                                                   Photo: e.Image,
                                                   Designation : e.Designation.Name,
                                            Employee: e,
                                            StartTime: null,
                                            StartHour: "",
                                            StartMinute: "",
                                            EndHour: "",
                                            EndMinute: "",
                                            EndTime: null,
                                            TotalHours: 0,
                                            //                                        NormalWorkingHours: $scope.PayrollSettings.DefaultWorkingHours,
                                            //                                        BreakHours: $scope.PayrollSettings.DefaultBreakHours,
                                            OverTimeHours: 0,
                                            CostCenters: angular.copy($scope.CostCenters2),
                                        }

                                        $scope.addData.EmployeeAttendanceDetails.push(detail);
                                        $scope.click(detail);
                                    })

                                }
                            }, function (err) {});

                        } else {

                            MainService.GetBalanceEmployees(tempemp).then(function (response2) {
                                if (response2.data) {

                                    angular.forEach(response2.data, function (e) {
                                        var detail = {
                                            EmployeeId: e.Id,
                                            mployeeName: e.Name,
                                             EmployeeCode: e.EmployeeId,
                                                   Photo: e.Image,
                                                   Designation : e.Designation.Name,
                                            Employee: e,
                                            StartTime: null,
                                            StartHour: "",
                                            StartMinute: "",
                                            EndHour: "",
                                            EndMinute: "",
                                            EndTime: null,
                                            TotalHours: 0,
                                            //                                        NormalWorkingHours: $scope.PayrollSettings.DefaultWorkingHours,
                                            //                                        BreakHours: $scope.PayrollSettings.DefaultBreakHours,
                                            OverTimeHours: 0,
                                            CostCenters: angular.copy($scope.CostCenters2),
                                        }

                                        $scope.addData.EmployeeAttendanceDetails.push(detail);
                                        $scope.click(detail);
                                    })

                                }
                            }, function (err) {});

                        }






                    } else {
                        toastr.error($scope.LanguageData.NetworkError);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }


            $scope.recheckall = function () {
                angular.forEach($scope.addData.EmployeeAttendanceDetails, function (e) {
                    $scope.click(e);
                })
            }

            $scope.click = function (data) {
                $scope.SelectedCE = data;

                var dateObj = $scope.addData.Date;
                var month = dateObj.getMonth() + 1;
                var day = dateObj.getDate();
                var year = dateObj.getFullYear();

                if (data.StartHour != "" && data.StartMinute == "") {
                    data.StartMinute = "00";
                }

                if (data.EndHour != "" && data.EndMinute == "") {
                    data.EndMinute = "00";
                }

                if (data.StartHour != "" && data.StartMinute != "") {
                    var startTime = year + "-" + month + "-" + day + " " + data.StartHour + ":" + data.StartMinute;
                    $scope.SelectedCE.StartTime = new Date(startTime);
                }

                if (data.EndHour != "" && data.EndMinute != "") {
                    var EndTime = year + "-" + month + "-" + day + " " + data.EndHour + ":" + data.EndMinute;
                    $scope.SelectedCE.EndTime = new Date(EndTime);
                }

                $scope.SelectedCE.OverTimeHours = 0;
                if ($scope.SelectedCE.StartTime != null && $scope.SelectedCE.EndTime != null &&
                    $scope.SelectedCE.StartTime != "" && $scope.SelectedCE.EndTime != "") {
                    $scope.SelectedCE.TotalHours = Math.abs($scope.SelectedCE.StartTime - $scope.SelectedCE.EndTime) / 36e5;
                    $scope.SelectedCE.TotalHours = Math.round($scope.SelectedCE.TotalHours * 100) / 100;
                }

                $scope.SelectedCE.IsStartNotPunched = false;
                $scope.SelectedCE.IsEndNotPunched = false;
                $scope.SelectedCE.IsOverTime = false;
                $scope.SelectedCE.IsUnderTime = false;
                $scope.SelectedCE.IsLateEntry = false;
                $scope.SelectedCE.IsEarlyCheckout = false;

                if ($scope.SelectedCE.StartTime == null && $scope.SelectedCE.EndTime != null) {
                    $scope.SelectedCE.IsStartNotPunched = true;
                }
                if ($scope.SelectedCE.EndTime == null && $scope.SelectedCE.StartTime != null) {
                    $scope.SelectedCE.IsEndNotPunched = true;
                }

                if ($scope.SelectedCE.StartTime != null && $scope.SelectedCE.EndTime != null &&
                    $scope.SelectedCE.StartTime != "" && $scope.SelectedCE.EndTime != "") {

                    $scope.SelectedCE.OverTimeHours = $scope.SelectedCE.TotalHours - $scope.addData.NormalWorkingHours;
                    $scope.SelectedCE.OverTimeHours = Math.round($scope.SelectedCE.OverTimeHours * 100) / 100;
                }


                if ($scope.SelectedCE.OverTimeHours > 0) {
                    $scope.SelectedCE.IsOverTime = true;
                }

                if ($scope.NormalLateStartTimeDate < $scope.SelectedCE.StartTime) {
                    $scope.SelectedCE.IsLateEntry = true;
                }
                if ($scope.SelectedCE.EndTime < $scope.NormalEarlyEndTimeDate && $scope.SelectedCE.EndTime != null) {
                    $scope.SelectedCE.IsEarlyCheckout = true;
                }

                if ($scope.SelectedCE.TotalHours == 0) {
                    if ($scope.SelectedCE.StartTime != null && $scope.SelectedCE.EndTime == null) {
                        $scope.SelectedCE.Status = "Present";
                    } else {
                        $scope.SelectedCE.Status = "Absent";
                    }
                } else {
                    $scope.SelectedCE.Status = "Absent";
                    if ($scope.SelectedCE.TotalHours >= $scope.addData.NormalHalfDayHours) {
                        $scope.SelectedCE.Status = "Present";
                    } else if ($scope.SelectedCE.TotalHours > 0) {
                        $scope.SelectedCE.Status = "Half Day";
                    }
                }
                if ($scope.SelectedCE.TotalHours < $scope.addData.NormalHalfDayHours && $scope.SelectedCE.Status != "Absent") {
                    $scope.SelectedCE.IsUnderTime = true;
                }


            }

            $scope.checkTimings = function () {

                var dateObjS = $scope.addData.Date;
                var monthS = dateObjS.getMonth() + 1;
                var dayS = dateObjS.getDate();
                var yearS = dateObjS.getFullYear();

                $scope.addData.IsHoliday = false;

                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                var dayName = days[$scope.addData.Date.getDay()];

                if ($scope.PayrollSettings.WeekOff1 == dayName || $scope.PayrollSettings.WeekOff2 == dayName) {
                    $scope.addData.IsHoliday = true;
                }


                var dataD = {
                    DateString: $scope.extractDate($scope.addData.Date)
                }
                MainService.CheckDateHoliday(dataD).then(function (response) {
                    if (response.data == true) {
                        $scope.addData.IsHoliday = true;
                    }
                }, function (err) {});

                //                if ($scope.addData.IsHoliday == false) {

                $scope.addData.NormalWorkingHours = $scope.PayrollSettings.DefaultWorkingHours;
                $scope.addData.DefaultBreakHours = $scope.PayrollSettings.DefaultBreakHours;
                $scope.addData.NormalStartTime = $scope.PayrollSettings.NormalStartTime;
                $scope.addData.NormalEndTime = $scope.PayrollSettings.NormalEndTime;
                $scope.addData.MinLateChekinTime = $scope.PayrollSettings.MinLateChekinStartTime;
                $scope.addData.MinCheckoutTime = $scope.PayrollSettings.MinCheckoutEndTime;
                $scope.addData.NormalHalfDayHours = $scope.PayrollSettings.MinHalfDayHours;
                $scope.addData.NormalPresentHours = $scope.PayrollSettings.MinPresentHours;

                if (dayName == 'Sunday') {
                    $scope.addData.NormalWorkingHours = $scope.PayrollSettings.DefaultSundayWorkingHours;
                    $scope.addData.NormalStartTime = $scope.PayrollSettings.SundayStartTime;
                    $scope.addData.NormalEndTime = $scope.PayrollSettings.SundayEndTime;
                    $scope.addData.MinLateChekinTime = $scope.PayrollSettings.SundayMinLateChekinTime;
                    $scope.addData.MinCheckoutTime = $scope.PayrollSettings.SundayMinCheckoutTime;
                    $scope.addData.NormalHalfDayHours = $scope.PayrollSettings.MinSundayHalfDayHours;
                    $scope.addData.NormalPresentHours = $scope.PayrollSettings.MinSundayPresentHours;
                } else if (dayName == 'Monday') {
                    $scope.addData.NormalWorkingHours = $scope.PayrollSettings.DefaultModnayWorkingHours;
                    $scope.addData.NormalStartTime = $scope.PayrollSettings.MondayStartTime;
                    $scope.addData.NormalEndTime = $scope.PayrollSettings.MondayEndTime;
                    $scope.addData.MinLateChekinTime = $scope.PayrollSettings.MondayMinLateChekinTime;
                    $scope.addData.MinCheckoutTime = $scope.PayrollSettings.MondayMinCheckoutTime;
                    $scope.addData.NormalHalfDayHours = $scope.PayrollSettings.MinMondayHalfDayHours;
                    $scope.addData.NormalPresentHours = $scope.PayrollSettings.MinMondayPresentHours;
                } else if (dayName == 'Tuesday') {
                    $scope.addData.NormalWorkingHours = $scope.PayrollSettings.DefaultTuesdayWorkingHours;
                    $scope.addData.NormalStartTime = $scope.PayrollSettings.TuesdayStartTime;
                    $scope.addData.NormalEndTime = $scope.PayrollSettings.TuesdayEndTime;
                    $scope.addData.MinLateChekinTime = $scope.PayrollSettings.TuesdayMinLateChekinTime;
                    $scope.addData.MinCheckoutTime = $scope.PayrollSettings.TuesdayMinCheckoutTime;
                    $scope.addData.NormalHalfDayHours = $scope.PayrollSettings.MinTuesdayHalfDayHours;
                    $scope.addData.NormalPresentHours = $scope.PayrollSettings.MinTuesdayPresentHours;
                } else if (dayName == 'Wednesday') {
                    $scope.addData.NormalWorkingHours = $scope.PayrollSettings.DefaultWednesdayWorkingHours;
                    $scope.addData.NormalStartTime = $scope.PayrollSettings.WednesdayStartTime;
                    $scope.addData.NormalEndTime = $scope.PayrollSettings.WednesdayEndTime;
                    $scope.addData.MinLateChekinTime = $scope.PayrollSettings.WednesdayMinLateChekinTime;
                    $scope.addData.MinCheckoutTime = $scope.PayrollSettings.WednesdayMinCheckoutTime;
                    $scope.addData.NormalHalfDayHours = $scope.PayrollSettings.MinWednesdayHalfDayHours;
                    $scope.addData.NormalPresentHours = $scope.PayrollSettings.MinWednesdayPresentHours;
                } else if (dayName == 'Thursday') {
                    $scope.addData.NormalWorkingHours = $scope.PayrollSettings.DefaultThursdayWorkingHours;
                    $scope.addData.NormalStartTime = $scope.PayrollSettings.ThursdayStartTime;
                    $scope.addData.NormalEndTime = $scope.PayrollSettings.ThursdayEndTime;
                    $scope.addData.MinLateChekinTime = $scope.PayrollSettings.ThursdayMinLateChekinTime;
                    $scope.addData.MinCheckoutTime = $scope.PayrollSettings.ThursdayMinCheckoutTime;
                    $scope.addData.NormalHalfDayHours = $scope.PayrollSettings.MinThursdayHalfDayHours;
                    $scope.addData.NormalPresentHours = $scope.PayrollSettings.MinThursdayPresentHours;
                } else if (dayName == 'Friday') {
                    $scope.addData.NormalWorkingHours = $scope.PayrollSettings.DefaultFridayWorkingHours;
                    $scope.addData.NormalStartTime = $scope.PayrollSettings.FridayStartTime;
                    $scope.addData.NormalEndTime = $scope.PayrollSettings.FridayEndTime;
                    $scope.addData.MinLateChekinTime = $scope.PayrollSettings.FridayMinLateChekinTime;
                    $scope.addData.MinCheckoutTime = $scope.PayrollSettings.FridayMinCheckoutTime;
                    $scope.addData.NormalHalfDayHours = $scope.PayrollSettings.MinFridayHalfDayHours;
                    $scope.addData.NormalPresentHours = $scope.PayrollSettings.MinFridayPresentHours;
                } else if (dayName == 'Saturday') {
                    $scope.addData.NormalWorkingHours = $scope.PayrollSettings.DefaultSaturdayWorkingHours;
                    $scope.addData.NormalStartTime = $scope.PayrollSettings.SaturdayStartTime;
                    $scope.addData.NormalEndTime = $scope.PayrollSettings.SaturdayEndTime;
                    $scope.addData.MinLateChekinTime = $scope.PayrollSettings.SaturdayMinLateChekinTime;
                    $scope.addData.MinCheckoutTime = $scope.PayrollSettings.SaturdayMinCheckoutTime;
                    $scope.addData.NormalHalfDayHours = $scope.PayrollSettings.MinSaturdayHalfDayHours;
                    $scope.addData.NormalPresentHours = $scope.PayrollSettings.MinSaturdayPresentHours;
                }


                //                }

                $scope.NormalStartTimeDate = new Date(yearS + "-" + monthS + "-" + dayS + " " + $scope.addData.NormalStartTime);
                $scope.NormalEndTimeDate = new Date(yearS + "-" + monthS + "-" + dayS + " " + $scope.addData.NormalEndTime);

                $scope.NormalLateStartTimeDate = new Date(yearS + "-" + monthS + "-" + dayS + " " + $scope.addData.MinLateChekinTime);
                $scope.NormalEarlyEndTimeDate = new Date(yearS + "-" + monthS + "-" + dayS + " " + $scope.addData.MinCheckoutTime);

            }

            $scope.changeDate = function () {

                $scope.PayrollSettings = {};
                MainService.GetPayrollSettingsGrade($scope.addData.GradeId).then(function (response) {
                    if (response.data) {
                        $scope.PayrollSettings = response.data;
                        $scope.checkDate();
                    } else {
                        toastr.error($scope.LanguageData.NetworkError);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });

            }

            $scope.checkDate = function () {

                $scope.grade = 0;
                if ($scope.addData.GradeId > 0) {
                    $scope.grade = $scope.addData.GradeId;
                }

                $scope.checkTimings();

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                var month = $scope.addData.Date.getMonth() + 1;
                var day = $scope.addData.Date.getDate();
                var year = $scope.addData.Date.getFullYear();

                MainService.CheckEmployeeAttendanceByDate(year, month, day, $scope.grade).then(function (response) {
                    if (response.data != null) {

                        if (response.data > 0) {

                            //                            $scope.PayrollSetting = {};
                            //                            MainService.GetPayrollSettings().then(function (response3) {
                            //                                $scope.PayrollSetting = response3.data;
                            //                            })

                            $scope.loadVoucher(response.data);

                            if ($state.current.name == "employeeAttendanceGrade") {
                                $scope.Employees = [];
                                MainService.EmployeesByGradeId($scope.addData.GradeId).then(function (response2) {
                                    $scope.Employees = response2.data;
                                })
                            } else {

                                $scope.Employees = [];
                                MainService.EmployeesInDropdown().then(function (response2) {
                                    $scope.Employees = response2.data;
                                })

                            }



                            $.LoadingOverlay("hide");


                        } else {

                            $scope.addData.Id = "";
                            $scope.addData.VoucherNo = "";
                            $scope.addData.Remarks = "";
                            $scope.addData.Field1 = "";
                            $scope.addData.Field2 = "";
                            $scope.addData.Field3 = "";
                            $scope.addData.Field4 = "";
                            $scope.addData.Field5 = "";
                            $scope.addData.EmployeeAttendanceDetails = [];

                            $.LoadingOverlay("hide");

                            $scope.CostCenters = angular.copy($scope.CostCenters2);

                            var dateObj = $scope.addData.Date;
                            var month = dateObj.getMonth() + 1;
                            var day = dateObj.getDate();
                            var year = dateObj.getFullYear();

                            var startTime = year + "-" + month + "-" + day + " 10:00";
                            var EndTime = year + "-" + month + "-" + day + " 00:00";


                            if ($state.current.name == "employeeAttendanceGrade") {

                                $scope.Employees = [];
                                MainService.EmployeesByGradeId($scope.addData.GradeId).then(function (response2) {
                                    $scope.Employees = response2.data;

                                    angular.forEach($scope.Employees, function (e) {
                                        var detail = {
                                            EmployeeId: e.Id,
                                            EmployeeName: e.Name,
                                            EmployeeCode: e.EmployeeId,
                                                   Photo: e.Image,
                                                   Designation : e.Designation.Name,
                                            Employee: e,
                                            StartTime: null,
                                            StartHour: "",
                                            StartMinute: "",
                                            EndHour: "",
                                            EndMinute: "",
                                            EndTime: null,
                                            TotalHours: 0,
                                            //                                            NormalWorkingHours: $scope.PayrollSettings.DefaultWorkingHours,
                                            //                                            BreakHours: $scope.PayrollSettings.DefaultBreakHours,
                                            OverTimeHours: 0,
                                            CostCenters: angular.copy($scope.CostCenters2),
                                            EmployeeAttendanceShifts: [],
                                        }
                                        $scope.addData.EmployeeAttendanceDetails.push(detail);
                                        $scope.click(detail);
                                    })


                                })

                            } else {

                                $scope.Employees = [];
                                MainService.EmployeesInDropdown().then(function (response2) {
                                    $scope.Employees = response2.data;

                                    angular.forEach($scope.Employees, function (e) {
                                        var detail = {
                                            EmployeeId: e.Id,
                                            EmployeeName: e.Name,
                                             EmployeeCode: e.EmployeeId,
                                                   Photo: e.Image,
                                                   Designation : e.Designation.Name,
                                            Employee: e,
                                            StartTime: null,
                                            StartHour: "",
                                            StartMinute: "",
                                            EndHour: "",
                                            EndMinute: "",
                                            EndTime: null,
                                            TotalHours: 0,
                                            //                                            NormalWorkingHours: $scope.PayrollSettings.DefaultWorkingHours,
                                            //                                            BreakHours: $scope.PayrollSettings.DefaultBreakHours,
                                            OverTimeHours: 0,
                                            CostCenters: angular.copy($scope.CostCenters2),
                                            EmployeeAttendanceShifts: [],
                                        }
                                        $scope.addData.EmployeeAttendanceDetails.push(detail);
                                        $scope.click(detail);
                                    })


                                })
                            }



                            //                            $scope.PayrollSetting = {};
                            //                            MainService.GetPayrollSettings().then(function (response3) {
                            //                                $scope.PayrollSetting = response3.data;
                            //
                            //                              
                            //
                            //
                            //
                            //                            })


                            MainService.GetNextEmployeeAttendanceNo().then(function (response) {
                                $scope.addData.VoucherNo = response.data;
                            })

                        }
                    } else {
                        $.LoadingOverlay("hide");
                        toastr.error($scope.LanguageData.NetworkError);
                    }
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });

            }

            $scope.Init = function () {


                $scope.addData = {
                    VoucherNo: "",
                    GradeId: "",
                    Date: new Date(),
                    Remarks: "",
                    EmployeeAttendanceDetails: [],
                }

                $scope.VoucherName = "Employee Attendance";
                $scope.IsGradePage = false;
                if ($state.current.name == "employeeAttendanceGrade") {
                    $scope.VoucherName = "Employee Attendance Grade Wise";
                    $scope.IsGradePage = true;

                    $scope.Grades = [];
                    MainService.GradesInDropdown().then(function (response) {
                        $scope.Grades = response.data;
                        if ($scope.Grades.length > 0) {
                            $scope.addData.GradeId = $scope.Grades[0].Id;



                            $.LoadingOverlay("show", {
                                image: "images/load.gif",
                            });

                            $scope.NormalStartTime = "10:00";
                            $scope.NormalEndTime = "18:00";

                            $scope.PayrollSettings = {};
                            MainService.GetPayrollSettingsGrade($scope.addData.GradeId).then(function (response) {
                                if (response.data) {
                                    $scope.PayrollSettings = response.data;

                                    $scope.getCostArrays();


                                    MainService.CostCentersInVoucher("Employee Attendance").then(function (response) {
                                        $scope.CostCenters = response.data;
                                        $scope.CostCenters2 = response.data;
                                        $scope.checkDate();
                                    });


                                } else {
                                    toastr.error($scope.LanguageData.NetworkError);
                                }
                                $.LoadingOverlay("hide");
                            }, function (err) {
                                toastr.error($scope.LanguageData.NetworkError);
                                $.LoadingOverlay("hide");
                            });




                        }
                    })




                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    $scope.NormalStartTime = "10:00";
                    $scope.NormalEndTime = "18:00";

                    $scope.PayrollSettings = {};
                    MainService.GetPayrollSettings($scope.addData).then(function (response) {
                        if (response.data) {
                            $scope.PayrollSettings = response.data;


                            MainService.CostCentersInVoucher("Employee Attendance").then(function (response) {
                                $scope.CostCenters = response.data;
                                $scope.CostCenters2 = response.data;
                                $scope.checkDate();
                            });


                        } else {
                            toastr.error($scope.LanguageData.NetworkError);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });

                }






            }
            $scope.Init();


            $scope.getCostArrays = function () {

                $scope.CostCenter1Array = [];
                $scope.CostCenter2Array = [];
                $scope.CostCenter3Array = [];
                $scope.CostCenter4Array = [];
                $scope.CostCenter5Array = [];

                if ($scope.PayrollSettings.IsCostCenter1 && $scope.PayrollSettings.CostCenter1Id > 0) {
                    MainService.CostCenterSubList($scope.PayrollSettings.CostCenter1Id).then(function (response) {
                        $scope.CostCenter1Array = response.data;
                    });
                }
                if ($scope.PayrollSettings.IsCostCenter2 && $scope.PayrollSettings.CostCenter2Id > 0) {
                    MainService.CostCenterSubList($scope.PayrollSettings.CostCenter2Id).then(function (response) {
                        $scope.CostCenter2Array = response.data;
                    });
                }
                if ($scope.PayrollSettings.IsCostCenter3 && $scope.PayrollSettings.CostCenter3Id > 0) {
                    MainService.CostCenterSubList($scope.PayrollSettings.CostCenter3Id).then(function (response) {
                        $scope.CostCenter3Array = response.data;
                    });
                }
                if ($scope.PayrollSettings.IsCostCenter4 && $scope.PayrollSettings.CostCenter4Id > 0) {
                    MainService.CostCenterSubList($scope.PayrollSettings.CostCenter4Id).then(function (response) {
                        $scope.CostCenter4Array = response.data;
                    });
                }
                if ($scope.PayrollSettings.IsCostCenter5 && $scope.PayrollSettings.CostCenter5Id > 0) {
                    MainService.CostCenterSubList($scope.PayrollSettings.CostCenter5Id).then(function (response) {
                        $scope.CostCenter5Array = response.data;
                    });
                }

            }


            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }


            $scope.AddData = function () {

                var err = "";
                var ic = 1;
                var icc = 0;

                angular.forEach($scope.addData.EmployeeAttendanceDetails, function (e) {
                    if (e.EmployeeId == "" && (e.StartTime != "" || e.EndTime != "")) {
                        err = "Employee Not Selected for row " + ic;
                    } else if (e.EmployeeId > 0 && (e.StartTime == "" || e.EndTime == "")) {
                        err = "Employee Not Selected for row " + ic;
                    }

                    if (e.EmployeeId > 0 && e.StartTime != "" && e.EndTime != "") {
                        icc = 1;
                    }

                    ic = ic + 1;

                    if (e.TotalHours > 0) {
                        e.EmployeeAttendanceCosts = [];
                        angular.forEach(e.CostCenters, function (a) {
                            if (a.Section == "Body") {
                                if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                    $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                                } else {
                                    if (a.SelectedCostCenterId > 0) {
                                        var cst = {
                                            CostCenterId: a.SelectedCostCenterId,
                                        }
                                        e.EmployeeAttendanceCosts.push(cst);
                                        console.log(e);
                                    }
                                }
                            }
                        })
                    }

                })

                if (err != "") {
                    toastr.warning(err);
                } else if (icc == 0) {
                    toastr.warning("Invalid Details");
                } else {


                    $scope.addData.EmployeeAttendanceCosts = [];
                    angular.forEach($scope.CostCenters, function (e) {
                        if (e.Section == "Head") {
                            if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                                $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                            } else {
                                if (e.SelectedCostCenterId > 0) {
                                    var cst = {
                                        CostCenterId: e.SelectedCostCenterId,
                                    }
                                    $scope.addData.EmployeeAttendanceCosts.push(cst);
                                }
                            }
                        }
                    })


                    $scope.addData.Month = $scope.addData.Date.getMonth() + 1;
                    $scope.addData.Day = $scope.addData.Date.getDate();
                    $scope.addData.Year = $scope.addData.Date.getFullYear();

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddEmployeeAttendance($scope.addData).then(function (response) {
                        if (response.data) {
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.NetworkError);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }


            $scope.selectedVisit = {};
            $scope.showVisits = function (data) {
                $scope.selectedVisit = data;
                $scope.visitData = {
                    EmployeeId: $scope.selectedVisit.EmployeeId,
                    StartTime: null,
                    StartHour: "",
                    StartMinute: "",
                    EndHour: "",
                    EndMinute: "",
                    EndTime: null,
                    TotalHours: 0,
                }
                $('#visitModal').modal('show');
            }

            $scope.refreshVisitRow = function () {
                $scope.visitData = {
                    EmployeeId: $scope.selectedVisit.EmployeeId,
                    StartTime: null,
                    StartHour: "",
                    StartMinute: "",
                    EndHour: "",
                    EndMinute: "",
                    EndTime: null,
                    TotalHours: 0,
                }
            }

            $scope.addVisitRow = function () {


                if ($scope.visitData.StartHour == "") {
                    toastr.warning("Select Starting Hour");
                } else if ($scope.visitData.StartMinute == "") {
                    toastr.warning("Select Starting Minute");
                } else if ($scope.visitData.EndHour == "") {
                    toastr.warning("Select Ending Hour");
                } else if ($scope.visitData.EndMinute == "") {
                    toastr.warning("Select Ending Minute");
                } else {

                    var dateObj = $scope.addData.Date;
                    var month = dateObj.getMonth() + 1;
                    var day = dateObj.getDate();
                    var year = dateObj.getFullYear();

                    var startTime = year + "-" + month + "-" + day + " " + $scope.visitData.StartHour + ":" + $scope.visitData.StartMinute;
                    $scope.visitData.StartTime = new Date(startTime);

                    var EndTime = year + "-" + month + "-" + day + " " + $scope.visitData.EndHour + ":" + $scope.visitData.EndMinute;
                    $scope.visitData.EndTime = new Date(EndTime);

                    if ($scope.visitData.StartTime != null && $scope.visitData.EndTime != null &&
                        $scope.visitData.StartTime != "" && $scope.visitData.EndTime != "") {
                        $scope.visitData.TotalHours = Math.abs($scope.visitData.StartTime - $scope.visitData.EndTime) / 36e5;
                        $scope.visitData.TotalHours = Math.round($scope.visitData.TotalHours * 100) / 100;
                    }

                    var invalid = false;
                    angular.forEach($scope.selectedVisit.EmployeeAttendanceShifts, function (e) {
                        if ($scope.visitData.StartTime >= e.StartTime && $scope.visitData.StartTime <= e.EndTime) {
                            invalid = true;
                        }

                        if ($scope.visitData.EndTime >= e.StartTime && $scope.visitData.EndTime <= e.EndTime) {
                            invalid = true;
                        }
                    })

                    if (invalid == false) {
                        $scope.selectedVisit.EmployeeAttendanceShifts.push(angular.copy($scope.visitData));
                        $scope.refreshVisitRow();
                        $scope.click2();
                    } else {
                        toastr.warning("Invalid Time");
                    }

                }

            }

            $scope.removeVisitRow = function (data) {
                var index = $scope.selectedVisit.EmployeeAttendanceShifts.indexOf(data);
                $scope.selectedVisit.EmployeeAttendanceShifts.splice(index, 1);
                $scope.click2();
            }


            $scope.click2 = function () {

                //                var invalidtime = false;
                //                if (index > 0) {
                //                    var previousarr = $scope.selectedVisit.EmployeeAttendanceShifts[index - 1];
                //                    if (data.StartTime >= previousarr.StartTime && data.StartTime <= previousarr.EndTime) {
                //                        invalidtime = true;
                //                    }
                //                    if (data.EndTime >= previousarr.StartTime && data.EndTime <= previousarr.EndTime) {
                //                        invalidtime = true;
                //                    }
                //                }
                //                alert(invalidtime);


                $scope.selectedVisit.TotalVisitHours = 0;
                angular.forEach($scope.selectedVisit.EmployeeAttendanceShifts, function (e) {
                    $scope.selectedVisit.TotalVisitHours = $scope.selectedVisit.TotalVisitHours + e.TotalHours;
                })

                $scope.selectedVisit.StartHour = $scope.selectedVisit.EmployeeAttendanceShifts[0].StartHour;
                $scope.selectedVisit.StartMinute = $scope.selectedVisit.EmployeeAttendanceShifts[0].StartMinute;

                var length = $scope.selectedVisit.EmployeeAttendanceShifts.length;
                length = length - 1;
                $scope.selectedVisit.EndHour = $scope.selectedVisit.EmployeeAttendanceShifts[length].EndHour;
                $scope.selectedVisit.EndMinute = $scope.selectedVisit.EmployeeAttendanceShifts[length].EndMinute;

                $scope.click($scope.selectedVisit);

            }


            $scope.saveVisit = function () {
                $('#visitModal').modal('hide');
            }

            $scope.GetBackVoucher = function (type) {
                var temp = 0;
                if ($scope.addData.Id > 0) {
                    temp = $scope.addData.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.grade = 0;
                if ($scope.addData.GradeId > 0) {
                    $scope.grade = $scope.addData.GradeId;
                }

                MainService.GetBackEmployeeAttendance(temp, type, $scope.grade).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.Init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.DeleteVoucher = function () {
                $('#deleteModal').modal('show');
            }


            $scope.DeleteWithConfirm = function (type) {

                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteEmployeeAttendance($scope.addData.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.Init();
                    } else {
                        toastr.error("Network Error");
                    }
                    $('#deleteModal').modal('hide');
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }


            ////// FILE UPLOAD /////////////

            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);

                        var tempArr = [];

                        angular.forEach(oJS, function (ee) {

                            angular.forEach($scope.addData.EmployeeAttendanceDetails, function (row) {

                                if (row.Employee.Name == ee.Name) {

                                    var dateObj = new Date();
                                    var month = dateObj.getUTCMonth() + 1;
                                    var day = dateObj.getUTCDate();
                                    var year = dateObj.getUTCFullYear();

                                    if (ee.StartTime != "" && ee.StartTime != null && ee.StartTime != undefined) {
                                        var startArray = ee.StartTime.split(':');
                                        row.StartHour = startArray[0];
                                        row.StartMinute = startArray[1];
                                        var startTime = year + "-" + month + "-" + day + " " + ee.StartTime;
                                        row.StartTime = new Date(startTime);
                                    } else {
                                        row.StartTime = null;
                                        row.StartHour = "";
                                        row.StartMinute = "";
                                    }

                                    if (ee.EndTime != "" && ee.EndTime != null && ee.EndTime != undefined) {
                                        var endArray = ee.EndTime.split(':');
                                        row.EndHour = endArray[0];
                                        row.EndMinute = endArray[1];
                                        var endTime = year + "-" + month + "-" + day + " " + ee.EndTime;
                                        row.EndTime = new Date(endTime);
                                    } else {
                                        row.EndTime = null;
                                        row.EndMinute = "";
                                        row.EndMinute = "";
                                    }

                                    $scope.click(row);
                                }


                            });

                        });

                        $scope.$apply();

                    });
                };

                reader.readAsBinaryString(oFile);



            }



                }])
